import { Component, OnInit } from '@angular/core';

export interface BoardStatusViewSelect{
  id: number
  name: string
  active: boolean
}

@Component({
  selector: 'app-board-status-view-select',
  templateUrl: './board-status-view-select.component.html',
  styleUrls: ['./board-status-view-select.component.scss', '../board-select.scss'],
})
export class BoardStatusViewSelectComponent implements OnInit {

  public statusViewItems: BoardStatusViewSelect[] = []
  public viewChanged: (data: BoardStatusViewSelect[]) => void

  constructor() { }

  ngOnInit() {}

  public toggle(item: BoardStatusViewSelect){
    item.active = !item.active
    this.viewChanged(this.statusViewItems)
  }

}
